import Button, { type ButtonProps } from '@carvana/ds-button';
import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const CardContainer = createComponent('a', {
  className:
    'flex h-[365px] w-[300px] flex-col justify-between overflow-hidden rounded-xl p-2xl'
});

export const CardTitleContainer = createComponent('div', {
  className: 'flex flex-col gap-lg'
});

export const CardTitle = createComponent<
  ElementWithProps<{ inverse?: boolean }>
>('h2', ({ inverse }) => ({
  className: cx(
    't-heading-xl',
    inverse ? 'text-text-inverse' : 'text-text-strong'
  )
}));

export const CardSubtitle = createComponent<
  ElementWithProps<{ inverse?: boolean }>
>('p', ({ inverse }) => ({
  className: cx(
    't-body-sm',
    inverse ? 'text-text-inverse' : 'text-text-default'
  )
}));

export const CardCtaButton = createComponent<ElementWithProps<ButtonProps>>(
  Button,
  {
    className: 'mx-auto w-full',
    size: 'md'
  }
);
